import { UniversalExportsExporterFilterKindEnum } from 'generated/resources/graphql'

export const requiresOptions = (kind: UniversalExportsExporterFilterKindEnum) =>
  kind === 'singlechoice' || kind === 'multiplechoice'
